import type { ClerkProvider } from '@clerk/react';
import type { ComponentProps } from 'react';

type ClerkAppearance = NonNullable<ComponentProps<typeof ClerkProvider>['appearance']>;

/** Shared Clerk UI tokens — keep org switcher styling out of brittle `.cl-*` selectors in Layout. */
export const clerkAppearance: ClerkAppearance = {
  variables: {
    colorPrimary: 'var(--color-brand-600, #2563eb)',
    borderRadius: '0.5rem',
  },
  elements: {
    organizationSwitcherTrigger:
      'h-9 rounded-lg border border-slate-200 bg-white text-sm dark:border-slate-700 dark:bg-slate-800',
    organizationSwitcherPopoverCard: 'rounded-xl shadow-xl',
  },
};
